import { useState } from 'react';

/**
 * 写真撮影注意喚起の「了承済み」状態管理 (REQ-4.1.11、REQ-8.5.1)。
 *
 * Phase 2 minimum: localStorage 保管。
 * Phase 4+ (写真機能実装時): 投稿フローで初回のみ modal を強制表示、再表示は
 *   SettingsModal から reset 可能にする (旧 SettingsModal.tsx L140 `resetPhotoNotice`)。
 *
 * 旧 lib/db.ts の `getMeta/setMeta('photoNoticeAcknowledged', ...)` 相当を localStorage に。
 */

const STORAGE_KEY = 'cw.photoNotice.acknowledged.v1';

function load(): boolean {
  if (typeof localStorage === 'undefined') return false;
  try {
    return localStorage.getItem(STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

function persist(value: boolean): void {
  if (typeof localStorage === 'undefined') return;
  try {
    if (value) {
      localStorage.setItem(STORAGE_KEY, 'true');
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    /* quota / private mode 等は無視 */
  }
}

export function usePhotoNotice(): {
  acknowledged: boolean;
  acknowledge: () => void;
  reset: () => void;
} {
  const [acknowledged, setAck] = useState<boolean>(() => load());

  function acknowledge(): void {
    setAck(true);
    persist(true);
  }

  function reset(): void {
    setAck(false);
    persist(false);
  }

  return { acknowledged, acknowledge, reset };
}
